"use client";

import { Popover, PopoverContent, PopoverTrigger } from "@/03-presenters/components/ui/popover";
import { cx } from "class-variance-authority";
import Link from "@/03-presenters/widgets/LinkWithCountryCode";
import { usePathname } from "next/navigation";
import "./Navigation.css";
import { create } from "zustand";
import { useUserInfo } from "@/app/[locale]/hooks";
import { countryStore } from "./MultiCountrySelect";
import CustomCreativity from "./CustomCreativity";
import CustomDataInsight from "./CustomDataInsight";
import CustomKnowledge from "./CustomKnowledge";
export const openTitleStore = create<{
  locked: boolean;
  openTitle: string | null;
  navigating: boolean;
  setOpenTitle: (t: string | null) => void;
  setLocked: (l: boolean) => void;
  setNavigating: (n: boolean) => void;
}>(set => ({
  locked: false,
  openTitle: null,
  navigating: false,
  setOpenTitle: openTitle => set({
    openTitle
  }),
  setLocked: locked => set({
    locked
  }),
  setNavigating: navigating => set({
    navigating
  })
}));
function Navigation({
  title,
  isSelected,
  isHomePage,
  customPopoverContent,
  href,
  target
}: {
  title: string;
  isSelected: boolean;
  isHomePage: boolean;
  customPopoverContent?: React.ReactNode;
  href?: string;
  target?: string;
}) {
  const openTitle = openTitleStore(state => state.openTitle);
  const setOpenTitle = openTitleStore(state => state.setOpenTitle);
  const locked = openTitleStore(state => state.locked);
  const setLocked = openTitleStore(state => state.setLocked);
  const navigating = openTitleStore(state => state.navigating);
  const setNavigating = openTitleStore(state => state.setNavigating);
  const isHovering = openTitle === title && !navigating;
  return <Popover open={openTitle === title && !navigating} data-sentry-element="Popover" data-sentry-component="Navigation" data-sentry-source-file="Navigation.tsx">
      <PopoverTrigger onMouseEnter={() => {
      if (!navigating) {
        setOpenTitle(title);
        setLocked(true);
      }
    }} onMouseLeave={() => {
      setLocked(false);
    }} onClick={() => {
      setOpenTitle(null);
      setNavigating(true);
      setTimeout(() => {
        setNavigating(false);
      }, 500);
    }} id="hover-card-trigger" className="relative flex cursor-pointer items-center gap-1 text-medium font-normal" data-sentry-element="PopoverTrigger" data-sentry-source-file="Navigation.tsx">
        <Link className={cx("text-nowrap hover:font-medium", isSelected && "font-medium !text-[#000]", isHomePage && "text-[#A4A4AB]  hover:text-white", !isHomePage && "text-[#666] hover:text-[#000]")} href={href || ""} target={target} data-sentry-element="Link" data-sentry-source-file="Navigation.tsx">
          {title}
        </Link>
        <div className={cx("absolute left-0 h-0.5 w-full transition-opacity duration-300", isHovering ? "opacity-100" : "opacity-0", isHomePage ? "bg-white" : "bg-[#275AFF]", isHomePage ? "-bottom-5" : "-bottom-[18px]")} />
      </PopoverTrigger>
      <PopoverContent onMouseLeave={() => {
      if (!locked) {
        setOpenTitle(null);
      }
    }} onInteractOutside={() => {
      if (!locked) {
        setOpenTitle(null);
      }
    }} align="start" className={cx("flex w-[100vw] gap-12 rounded-none border-x-0 border-y-0 pb-6 pl-0 pt-8 backdrop-blur-[20px]", isHomePage ? "border-b-[#6D7784] bg-[rgba(22,20,25,0.90)]" : "border-gray-3 bg-white ", !customPopoverContent && "invisible")} data-sentry-element="PopoverContent" data-sentry-source-file="Navigation.tsx">
        {customPopoverContent}
      </PopoverContent>
    </Popover>;
}
export function TikTokNavigation({
  isHomePage = false
}: {
  isHomePage?: boolean;
}) {
  const pathname = usePathname();
  const isSelected = pathname.includes("tiktok") || pathname.includes("shopify");
  const countryCode = countryStore(state => state.countryCode);
  return <Navigation customPopoverContent={<CustomDataInsight isHomePage={isHomePage} />} title="数据洞察" isSelected={isSelected} isHomePage={isHomePage} href="/tiktok/dashboard/product-dashboard" data-sentry-element="Navigation" data-sentry-component="TikTokNavigation" data-sentry-source-file="Navigation.tsx" />;
}
export function AIToolNavigation({
  isHomePage = false
}: {
  isHomePage?: boolean;
}) {
  const pathname = usePathname();
  const isSelected = pathname.includes("aiTool");
  return <Navigation title="创意工坊" isSelected={isSelected} customPopoverContent={<CustomCreativity isHomePage={isHomePage} />} isHomePage={isHomePage} href="/aiToolV2/dashboard" data-sentry-element="Navigation" data-sentry-component="AIToolNavigation" data-sentry-source-file="Navigation.tsx" />;
}
export function KnowledgeNavigation({
  isHomePage = false
}: {
  isHomePage?: boolean;
}) {
  const pathname = usePathname();
  const isSelected = pathname.includes("konwledge");
  return <Navigation title="跨境智库" isSelected={isSelected} isHomePage={isHomePage} customPopoverContent={<CustomKnowledge isHomePage={isHomePage} />} href="/konwledge" data-sentry-element="Navigation" data-sentry-component="KnowledgeNavigation" data-sentry-source-file="Navigation.tsx" />;
}
export function AiNavigation({
  isHomePage = false
}: {
  isHomePage?: boolean;
}) {
  const pathname = usePathname();
  const isSelected = pathname === "/ai";
  return <Navigation title="小匠 AI" isSelected={isSelected} isHomePage={isHomePage} href="/ai" target="_blank" data-sentry-element="Navigation" data-sentry-component="AiNavigation" data-sentry-source-file="Navigation.tsx" />;
}